<template>
    <div class="RushRepairManagement">
        <el-form :inline="true" class="leader-style-form">
            <el-form-item label="抢修单号">
                <el-input v-model="searchForm.rush_repair_no" placeholder="请输入抢修单号"></el-input>
            </el-form-item>
            <el-form-item label="抢修负责人">
                <el-input v-model="searchForm.leader_name" placeholder="请输入抢修负责人"></el-input>
            </el-form-item>
            <el-form-item label="回填情况">
                <el-select v-model="searchForm.backfill_state">
                    <el-option
                        v-for="item in stateList"
                        :key="item.stateCode"
                        :label="item.stateName"
                        :value="item.stateCode"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-button
                type="warning"
                @click="getTable"
                size="medium"
                class="leader-common-button"
                style="float: right; margin-left: 10px;"
            >查询</el-button>
            <el-button
                type="primary"
                @click="addNewOne('addForm')"
                style="float: right"
                size="medium"
                class="leader-common-button"
            >新增</el-button>
        </el-form>

        <div class="table-wrap">
            <el-table
                ref="singleTable"
                :data="tableJson"
                border
                style="width: 100%"
                class="leader-style-table"
            >
                <!--@current-change="handleCurrentChange"-->
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <el-table-column label="抢修单号" property="rush_repair_no" align="left"></el-table-column>
                <el-table-column label="抢修负责人" property="leader_name" align="left"></el-table-column>
                <el-table-column label="抢修人员" property="worker_names" align="center"></el-table-column>
                <el-table-column label="抢修内容" property="content" align="center"></el-table-column>
                <el-table-column label="派单时间" property="op_date" align="center"></el-table-column>
                <el-table-column label="抢修状态" property="rush_repair_state_name" align="center"></el-table-column>
                <el-table-column label="回填情况" property="backfill_state_name" align="center"></el-table-column>
                <el-table-column label="修改" width="250" align="center">
                    <template slot-scope="scope">
                        <span v-if="'0' == scope.row.backfill_state">
                            <span v-if="'0' == user_level">
                                <el-button
                                    @click="changeItemShow(scope.row, '0')"
                                    type="text"
                                    class="button-check"
                                >
                                    <i class="iconfont iconeditor"></i>
                                    <span class="inner-text">修改</span>
                                </el-button>
                            </span>
                            <span v-else>
                                <el-button
                                    @click="changeItemShow(scope.row, '1')"
                                    type="text"
                                    class="button-custom"
                                >
                                    <i class="iconfont iconeditor"></i>
                                    <span class="inner-text">抢修回填</span>
                                </el-button>
                            </span>
                        </span>
                        <span v-else>
                            <el-button
                                @click="changeItemShow(scope.row, '1')"
                                type="text"
                                class="button-custom"
                            >
                                <i class="iconfont iconchakan" style="font-size: 0.9rem"></i>
                                <span class="inner-text">查看回填</span>
                            </el-button>
                        </span>

                        <el-button
                            v-if="'0' == scope.row.backfill_state"
                            @click="defentDialog(scope.row)"
                            type="text"
                            class="button-modify"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">登记缺陷</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="button-delete"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                class="leader-style-pagination"
            ></el-pagination>
        </div>
        <Repair_add
            :addshow.sync="addshow"
            :tree_Names="tree_Names"
            :tree_ids="tree_ids"
            :chooseRow="chooseRow"
            :isnew="isnew"
        ></Repair_add>
        <repair_return
            :returnShow.sync="returnShow"
            :chooseRow="chooseRow"
            v-bind:errorTableData1="errorTableData1"
        ></repair_return>
        <addDefectManege
            :defentDialogVisible.sync="defentDialogVisible"
            @updateBeginData="updateBeginData"
            class="leader-dialog"
        ></addDefectManege>
    </div>
</template>

<script>
import * as api from '../api/index';
import Tree from '@/comon/components/tree.vue';
import Collapes from '@/comon/components/collapse-block.vue';
import Repair_return from './repair_return.vue';
import Repair_add from './repair_add.vue';
import addDefectManege from './repair_defent_dialog.vue';
import Bus from '@/utils/eventBus.js';

export default {
    name: 'RushRepair',
    provide() {
        return {
            reload: this.reload,
        };
    },
    components: {
        addDefectManege,
        Repair_return,
        Repair_add,
        'me-tree': Tree,
        'me-collapes': Collapes,
    },
    data() {
        return {
            isRouterAlive: true,
            treeList: [],
            tableJson: [],
            treeLoading: false,
            tree_id: '1',
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            width: 'calc(100% - 370px)',
            tree_ids: '',
            tree_Names: '',
            stateList: [
                {
                    stateName: '全部',
                    stateCode: '',
                },
                {
                    stateName: '未回填',
                    stateCode: '0',
                },
                {
                    stateName: '已回填',
                    stateCode: '1',
                },
            ],
            formLabelWidth: '100px',
            // 分页器数据
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            addshow: false,
            returnShow: false,
            defentDialogVisible: false,
            errorTableData: [],
            searchForm: {
                leader_name: '',
                op_date: '',
                rush_repair_no: '',
                backfill_state: '',
            },
            chooseRow: {},
            isnew: true,
            errorTableData1: [],
            user_level: '2',
        };
    },
    created() {
        this.getUserInfo();
        this.getPointTree();
        this.getTable();
        Bus.$on('refresh', (message) => {
            //一些操作，message就是从top组件传过来的值
            this.getTable();
        });
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },

        // 获取table列表
        getTable() {
            api.getRushRepairs({
                leader_name: this.searchForm.leader_name,
                op_date: this.searchForm.op_date,
                rush_repair_no: this.searchForm.rush_repair_no,
                backfill_state: this.searchForm.backfill_state,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }).then((res) => {
                if (res.error_code === '0') {
                    this.tableJson = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        // 获取table列表
        getUserInfo() {
            api.getUserInfo({}).then((res) => {
                if (res.error_code === '0') {
                    this.user_level = res.bus_json.user_level;
                }
            });
        },
        /**
         * 登记缺陷
         * */
        defentDialog(row) {
            this.defentDialogVisible = true;
        },
        /**
         *登记完缺陷刷新数据
         */
        updateBeginData() { },
        // 删除抢修
        deleteItemShow(row) {
            this.$confirm('确认删除该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    api.deleteRushRepair({
                        rush_repair_id: row.rush_repair_id,
                    }).then((res) => {
                        if (res.error_code === '0') {
                            this.getTable();
                            this.$message({
                                type: 'success',
                                message: '删除成功！',
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '未删除',
                    });
                });
        },
        // 新增按钮点击
        addNewOne(formName) {
            // if (this.tree_Names.length == 0) {
            //     this.addshow = false;
            //     this.$message("请先选择设备！");
            // } else {
            this.addshow = true;
            this.isnew = true;
            // }
        },
        // table内修改按钮点击
        changeItemShow(sth, title) {
            if ('0' === title) {
                this.chooseRow = sth; //赋值当前选择行数据
                this.addshow = true; //显示新增/修改页面
                this.isnew = false;
            } else {
                this.chooseRow = sth; //赋值当前选择行数据
                this.errorTableData1.push({}); //重新push数据，通知回填页面刷新数据
                this.returnShow = true; //显示回填页面
            }
        },
        getPointTree() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeList = res.bus_json;
                    if (this.currentTreeNode && this.currentTreeNode.tree_id) {
                        this.$nextTick(() => {
                            // this.$refs.myTree.$refs.tree.setCurrentNode(this.currentTreeNode);
                        });
                    } else {
                        this.$nextTick(() => {
                            // this.$refs.myTree.$refs.tree.setCurrentNode(this.treeList[0]);
                            // this.handleTreeNodeClick(this.treeList[0]);
                        });
                    }
                }
                this.treeLoading = false;
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getTable();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getTable();
        },
        handleTreeNodeClick(select) {
            (this.tree_ids = ''),
                this.$refs.myTree.$refs.tree
                    .getCheckedKeys()
                    .forEach((item) => {
                        this.tree_ids += item + ',';
                    });
            if (this.tree_Names.match(select.tree_name)) {
                //判断若已经包含当前选择id，则表示当前操作为取消选择，故把当前节点去掉
                this.tree_Names = this.tree_Names.replace(
                    select.tree_name + ',',
                    ''
                );
            } else {
                this.tree_Names += select.tree_name + ',';
            }
        },
        collapesCb(collapes) {
            this.width = collapes ? 'calc(100% - 370px)' : 'calc(100% - 56px)';
        },
    },
};
</script>

<style scoped lang="scss">
.RushRepairManagement {
    /* background: #fff; */
    // width: 100%;
    // height: 85%;
    // display: flex;
    // flex-direction: row;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        height: 650px;
    }
    .tree-wrap {
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;
        width: 280px;
        overflow: hidden;
        box-sizing: border-box;
    }

    .right_container {
        box-sizing: border-box;
        // margin: 4px 30px 10px 0;
    }

    .inputclass {
        .el-input__inner {
            background-color: transparent !important;
            border: 1px solid #277ea3;
        }
    }

    .form-table {
        width: 97%;
        margin-left: 20px;
        height: 550px !important;
        margin-bottom: 20px;
        overflow-y: auto;

        .leader-style-table {
            height: auto !important;
        }
    }

    .btn_wrap {
        display: flex;
        justify-content: space-between;
        margin: 20px 10px;
    }
}
</style>
